import { call } from 'redux-saga/effects'
import { iconSync } from 'sync'

function *uploadFile(uploadId, file, featureType, featureId, entityIconType, allowedTypes, presentationId = 0, slideId = 0, force = false) {
	let localFile = ''
	if (file.type === 'local' || file.type === 'audio_recorder') {
		localFile = file.file[0]
	}
	const response = yield call(iconSync.uploadFilePicked, uploadId, localFile, file, featureType, featureId, entityIconType, allowedTypes, presentationId, slideId, force)
	return response
}

export default uploadFile
